import {Button, Col, Container, Image, Row} from 'react-bootstrap'
import {
  ROOT_URL,
  CONTACT_URL,
} from '../../constants/urls'
import { 
  ICON_ANXIETY,
  ICON_CONFIDENCE,
  ICON_WEIGHT_LOSS,
  ICON_STOP_SMOKING,
  ICON_CHILDREN,
  ICON_CAR,
  ICON_STRESS,
  ICON_IBS,
  ICON_ABUSE,
  ICON_PAST_LIFE,
  ICON_FEAR
} from '../../constants/svgs'
import {useNavigate} from 'react-router'
import {localise} from '../../services/LocalizationServices'
import { CardItem } from '../../components/cards/CardItem'
import {Helmet} from 'react-helmet'

const Services = () => {
  const history = useNavigate()
  const toContactUs = () => {history(CONTACT_URL)}

  return (
    <div>
      <Helmet>
        <meta charSet='utf-8' name='description' content={localise('SEO.services.description')}/>
        <meta charSet='utf-8' name='keywords' content={localise('SEO.services.keywords')}/>
        <title>{localise('SEO.services.title')}</title>
      </Helmet>
      <Container className='padding-under-nav'>
        <div>
          <div className='header-section mb-3'>
            {localise('services.title')}
          </div>
          <div className='d-flex justify-content-center'>
            <nav aria-label="breadcrumb">
              <ol className="breadcrumb">
                <li className="breadcrumb-item">
                  <a href={ROOT_URL}>{localise('nav.home')}</a>
                </li>
                <li className="breadcrumb-item active" aria-current="page">
                  {localise('nav.services')}
                </li>
              </ol>
            </nav>
          </div>
          <div className='homepage-about-title text-center mt-5'>
            {localise('services.tagline')}
          </div>
          <div>
          <div className='about-Subheader text-center mt-4'>
            {localise('services.introTitle')}
          </div>
          <div className='w-100 my-4'>
              <div className='about-normal text-center'>
                {localise('services.introDesc')}
              </div>
            </div>
          </div>
          <div className='w-100 text-center homepage-connect-btn'>
              <Button
                variant='primary'
                className='font-button-bold d-inline-block mx-auto py-3 px-5 homepage-connect-btn'
                onClick={toContactUs}>
                {localise('homepage.topButton')}
              </Button>
          </div>
        </div>
        <div>
          <div className='my-4'>
            <div className="services-cards">
              <CardItem 
                image={ICON_ANXIETY} 
                title={localise('services.anxietyTitle')} 
                description={localise('services.anxietyDesc')}
              />
              <CardItem 
                image={ICON_CONFIDENCE} 
                title={localise('services.confidenceTitle')} 
                description={localise('services.confidenceDesc')}
              />
              <CardItem 
                image={ICON_FEAR} 
                title={localise('services.fearsTitle')} 
                description={localise('services.fearsDesc')}
              />
              <CardItem 
                image={ICON_ABUSE} 
                title={localise('services.abuseTitle')} 
                description={localise('services.abuseDesc')}
              />
              <CardItem 
                image={ICON_WEIGHT_LOSS} 
                title={localise('services.weightTitle')} 
                description={localise('services.weightDesc')}
              />
              <CardItem 
                image={ICON_STOP_SMOKING} 
                title={localise('services.smokingTitle')} 
                description={localise('services.smokingDesc')}
              />
              <CardItem 
                image={ICON_IBS} 
                title={localise('services.ibsTitle')} 
                description={localise('services.ibsDesc')}
              />
              <CardItem 
                image={ICON_CHILDREN} 
                title={localise('services.childbirthTitle')} 
                description={localise('services.childbirthDesc')}
              />
              <CardItem 
                image={ICON_STRESS} 
                title={localise('services.stressTitle')} 
                description={localise('services.stressDesc')}
              />
              <CardItem 
                image={ICON_CAR} 
                title={localise('services.nervesTitle')} 
                description={localise('services.nervesDesc')}
              />
              <CardItem 
                image={ICON_PAST_LIFE} 
                title={localise('services.pastLifeTitle')} 
                description={localise('services.pastLifeDesc')}
              />
            </div>
          </div>
        </div>
      </Container>
    </div>
  )
}

export default Services